import HeadTermInput from "./HeadTermInput/HeadTermInput";
import AdditionalTermInput from "./AdditionalTermInput/AdditionalTermInput";

function openUrlInIncognito(url) {
  window.open(url, "_blank", "incognito=yes");
}

function IncognitoAnchor({ url, children }) {
  return (
    <a
      onClick={(e) => {
        e.preventDefault();
        openUrlInIncognito(url);
      }}
    >
      {children}
    </a>
  );
}

const inputDetailsArr = [
  {
    source: "amazonSuggestedSearch",
    backgroundId: "amazon-suggested-search-info",
    label: "\u2605 GOLD KEYWORDS",
    subLabel: "The 30-50 best overall keywords.",
    desc: `(15-25 terms) Hand selected terms from Amazon's search suggestions the highest priority searches that will be primary in the keyword generation results and should always remain in your final term selection.`,
    ExpandedDescription: (
      <div>
        <ul className="input-desc-detail-list">
          <li>
            <b>Goal:</b> Enter the most valuable and relevant 'gold' terms that
            are likely to drive the bulk of the traffic and sales of the
            product.
          </li>
          <li>
            <b>
              Note:{" "}
              <i>
                All keyword phrases entered in this data field will be included
                in the results.
              </i>
            </b>{" "}
            Choose terms carefully as this section has the biggest impact on
            generated output.
          </li>
          <li>
            <b>Source (~60%):</b> Top{" "}
            <b>'Priority Score' keywords from Viral Launch.</b> Search the seed
            term in '
            <a
              target="_blank"
              href="https://app.viral-launch.com/sellers/launch-staging/pages/keyword-research.html#/"
            >
              Keyword Research
            </a>
            '.
          </li>
          <li>
            <b>Source (~40%):</b> Top <b>Amazon Suggested Search</b> terms.
            Identify the keywords Amazon is driving traffic to by opening{" "}
            <IncognitoAnchor url={"https://www.amazon.com/"}>
              Amazon
            </IncognitoAnchor>{" "}
            in an Incognito window and entering the seed term one letter at a
            time, gathering all relevant suggestions. Phrases can be selected
            and copied right from Amazon's suggestions list. Aggregate results
            and delete irrelevant phrases.
          </li>
        </ul>
      </div>
    ),
  },
  {
    source: "amazonAdPhrases",
    backgroundId: "amazon-ad-phrases-info",
    label: "Amazon Ads",
    subLabel: "Up to 100 best-converting ad phrases.",
    desc: `(Terms with minimum of 3 conversions) Amazon Ad Phrases are provided by Amazon and aggregated based on the specific product. Once gathered from Amazon, place the results here to be enhance the keyword generation results.`,
    ExpandedDescription: (
      <div>
        <ul className="input-desc-detail-list">
          <li>
            <b>Goal:</b> Identify top keywords that are driving conversions.
          </li>
          <li>
            <p>
              <b>Process: </b>
            </p>
            <ol className="input-desc-detail-list sub-list">
              <li>
                <b>Navigate:</b> Go to Seller Central → Advertising →{" "}
                <a
                  target="_blank"
                  href="https://advertising.amazon.com/cm/campaigns?merchantId=A3N6KXG98LP7EA"
                >
                  Campaign Manager
                </a>
                .
              </li>
              <li>
                <b>Time Frame:</b> Set Date Range to 'Lifetime'.
              </li>
              <li>
                <b>Search:</b> One at a time, use obvious, and where applicable,
                adjacent product category terms (e.g., 'omega' and' 'fish') to
                gather relevant product campaigns from across our brands.
              </li>
              <li>
                <b>Select:</b> Click on a 'KEY' keyword campaign and on the next
                screen click on the associated Ad Group.
              </li>
              <li>
                <b>Data:</b> Select 'Search Terms', opt for the
                longest-available period (typically 65 days), and export the
                data.
              </li>
              <li>
                <b>Conversion Threshold:</b> Typically, select ad phrases that
                have at least 2-3 orders. Use judgement here—some listings
                you'll struggle to get 50 keywords at ≥2 orders, and for some
                you may have &gt;200 terms and will need to use ≥5 orders to cap
                the list at 100 phrases.
              </li>
              <li>
                <b>Repeat:</b> Apply this process to all relevant campaigns for
                all related products.
              </li>
              <li>
                <b>Aggregate:</b> Combine results.{" "}
                <b>
                  <i>Include duplicate phrases</i>
                </b>{" "}
                as these are relevant to the quality of the results.
              </li>
            </ol>
          </li>
        </ul>
      </div>
    ),
  },
  {
    source: "viralLaunchKeywordResearch",
    backgroundId: "viral-launch-info",
    label: "Viral Launch (SEED)",
    subLabel: "Top 100 keywords from seed term.",
    desc: `(100 terms) based on quality of terms within the results of the Viral Launch Keyword Research.`,
    ExpandedDescription: (
      <div>
        <ul className="input-desc-detail-list">
          <li>
            <b>Goal:</b> Identify the seed term's best 'Priority Score'
            keywords.
          </li>
          <li>
            <p>
              <b>Process: </b>
            </p>
            <ol className="input-desc-detail-list sub-list">
              <li>
                <b>Navigate:</b> Go to Viral Launch's '
                <a
                  target="_blank"
                  href="https://app.viral-launch.com/sellers/launch-staging/pages/keyword-research.html#/"
                >
                  Keyword Research
                </a>
                ' section.
              </li>
              <li>
                <b>Search:</b> Enter seed term.
              </li>
              <li>
                <b>Data:</b> Download results, open CSV, verify that it's sorted
                by highest 'Priority Score' and select the top 100.
              </li>
            </ol>
          </li>
        </ul>
      </div>
    ),
  },
  {
    source: "viralLunchCompetitorAnalysis",
    backgroundId: "viral-launch-info",
    label: "Viral Launch (COMPETITOR)",
    subLabel: "(~15 mins) Top 100 keywords from #1 competitor analysis.",
    desc: `(100 terms) based on quality of terms within the results.`,
    ExpandedDescription: (
      <div>
        <ul className="input-desc-detail-list">
          <li>
            <b>Goal:</b> Analyze #1 competitor and get its best keywords.
          </li>
          <li>
            <b>Note: </b>This report can take up to 15 minutes or more to
            generate results.
          </li>
          <li>
            <p>
              <b>Process: </b>
            </p>
            <ol className="input-desc-detail-list sub-list">
              <li>
                <b>Navigate:</b> Go to Viral Launch, then navigate to '
                <a
                  target="_blank"
                  href="https://app.viral-launch.com/sellers/launch-staging/pages/competitor-intelligence.html#/"
                >
                  Competitor Intelligence
                </a>
                '.
              </li>
              <li>
                <b>Track:</b> Select 'Track New Competitor', enter the ASIN of
                your top competitor, and click 'Track Product'.
              </li>
              <li>
                <b>Let it Run:</b> Leave the query running in the background and
                work on other tasks until it's finished.
              </li>
              <li>
                <b>Data:</b> Once results are available, check the top box and
                choose 'Select all pages'. Click on 'Select', choose 'Export',
                and then click 'Apply' to download data.
              </li>
            </ol>
          </li>
        </ul>
      </div>
    ),
  },
  {
    source: "jungleScout",
    backgroundId: "jungle-scout-info",
    label: "Jungle Scout (SEED)",
    subLabel: "Top 100 keywords from seed term research.",
    desc: `(100 terms) based on quality of the terms within the Jungle Scouts results`,
    ExpandedDescription: (
      <div>
        <ul className="input-desc-detail-list">
          <li>
            <b>Goal:</b> Identify the most relevant, high-volume keywords from
            seed term research on Jungle Scout.
          </li>
          <li>
            <p>
              <b>Process: </b>
            </p>
            <ol className="input-desc-detail-list sub-list">
              <li>
                <b>Navigate:</b> Access Jungle Scout, go to 'Keywords' and then
                '
                <a
                  target="_blank"
                  href="https://members.junglescout.com/#/keyword"
                >
                  Keyword Scout
                </a>
                '.
              </li>
              <li>
                <b>Data:</b> Search your seed term and download results.
              </li>
              <li>
                <b>Volume:</b> Verify that the ranking is by '30-Day Search
                Volume' and delete everything after the first 300.
              </li>
              <li>
                <b>Relevancy:</b> Re-sort the remaining data by 'Relevancy
                Score' and select the top 100.
              </li>
            </ol>
          </li>
        </ul>
      </div>
    ),
  },
  {
    source: "amazonAnalytics",
    backgroundId: "amazon-analytics-info",
    label: "Amazon Analytics (SEED)",
    subLabel: "Up to 100 seed term phrases from Amazon searches.",
    desc: `(Head Term search) Amazon Brand analytics shows the top searches by frequency that contain your head term. Search your head term in both search boxes separately. and then .`,
    ExpandedDescription: (
      <div>
        <ul className="input-desc-detail-list">
          <li>
            <b>Goal:</b> Use Amazon's analytics tool to collect Amazon search
            phrases that are relevant to the seed term.
          </li>
          <li>
            <p>
              <b>Process: </b>
            </p>
            <ol className="input-desc-detail-list sub-list">
              <li>
                <b>Navigate:</b> Go to Seller Central, select 'Brands', and then
                '
                <a
                  target="_blank"
                  href="https://sellercentral.amazon.com/brand-analytics"
                >
                  Brand Analytics
                </a>
                '.
              </li>
              <li>
                <b>Data:</b> Click on 'Search Analytics' and choose 'Top Search
                Terms'; set the Reporting Range to 'Monthly' and typically
                select the current year and the latest full month of results,
                then click 'Apply'.
              </li>
              <li>
                <b>Filter:</b> Enter your seed term in 'Search Term', then click
                'Refine Results'.
              </li>
            </ol>
          </li>
        </ul>
      </div>
    ),
  },
  {
    source: "amazonAnalyticsComp",
    backgroundId: "amazon-analytics-info",
    label: "Amazon Analytics (COMPETITORS)",
    subLabel: "Top 100 searches driving traffic to competitors.",
    desc: `(Top 4 competitors search) Amazon Brand analytics shows the top searches by frequency that contain your head term. Search the top 4 ASINs for your head term.`,
    ExpandedDescription: (
      <div>
        <ul className="input-desc-detail-list">
          <li>
            <b>Goal:</b> Use Amazon's analytics tool to examine 6 top
            competitors' Amazon search traffic and identify phrases that are
            driving traffic to their products.
          </li>

          <li>
            <p>
              <b>Process: </b>
            </p>
            <ol className="input-desc-detail-list sub-list">
              <li>
                <b>Navigate:</b> Go to Seller Central, select 'Brands', and then
                '
                <a
                  target="_blank"
                  href="https://sellercentral.amazon.com/brand-analytics"
                >
                  Brand Analytics
                </a>
                '.
              </li>
              <li>
                <b>Data:</b> Click on 'Search Analytics' and choose 'Top Search
                Terms'; set the Reporting Range to 'Monthly' and typically
                select the current year and the latest full month of results,
                then click 'Apply'.
              </li>
              <li>
                <b>Filter:</b> In 'Top Clicked Products' enter the ASIN of
                Competitor #1 and click 'Refine Results'. Gather data and repeat
                for the ASINs of competitors #2-6.
              </li>
              <li>
                <b>Aggregate:</b> Combine all gathered results.{" "}
                <b>
                  <i>Include duplicate phrases</i>
                </b>{" "}
                as these are relevant to the quality of the results.
              </li>
            </ol>
          </li>
          <li>
            <b>Note: </b>If no data is available for any of the ASINs, just
            proceed with the available data from the other competitors.
          </li>
        </ul>
      </div>
    ),
  },

  {
    source: "titles",
    backgroundId: "titles-info",
    label: "Top Titles",
    subLabel: `Enter the 12 titles used in 'T-Gen' research.`,
    desc: `Titles`,
    ExpandedDescription: (
      <div>
        <ul className="input-desc-detail-list">
          <li>
            <b>Goal:</b> Enter the same titles used in the 'T-Gen' process.
          </li>
          <li>
            <b>Criteria:</b> These should be the top 4 titles from each of the 3
            search terms.
          </li>
        </ul>
      </div>
    ),
  },
];

const tGenInputDetailsArr = [
  {
    source: "titles",
    backgroundId: "titles-info",
    label: "Top Titles",
    subLabel: `12 titles, top 4 from each of 3 search terms.`,
    desc: `12 titles, top 4 from each of 3 search terms.`,
    ExpandedDescription: (
      <div>
        <ul className="input-desc-detail-list">
          <li>
            <b>Goal:</b> Gather titles of the 4 highest-ranking products for
            each of 3 targeted search terms.
          </li>

          <li>
            <p>
              <b>Process: </b>
            </p>
            <ol className="input-desc-detail-list sub-list">
              <li>
                <b>Navigate:</b> Open{" "}
                <IncognitoAnchor url={"https://www.amazon.com/"}>
                  Amazon
                </IncognitoAnchor>{" "}
                in an Incognito window (in Chrome, Ctrl+Shift+N) and enter the
                first search term.
              </li>
              <li>
                <b>Collect:</b> Right-click on the top 4 organic results to open
                them in new tabs, then copy the product titles from each.
              </li>
              <li>
                <b>Repeat:</b> Close the browser window and{" "}
                <b>
                  <i>re-open a fresh Incognito browser</i>
                </b>{" "}
                to repeat the process for each of the other search terms.
              </li>
              <li>
                <b>Generate:</b> Aggregate and enter the 12 collected titles
                into the text box, click 'Generate' and use 'Minimum 3
                frequency' results.
              </li>
            </ol>
          </li>
          <li>
            <b>Note: </b>
            <b>
              <i>Don't de-dupe—</i>
            </b>
            if a product is showing up 2-3 times across searches, it's relevant
            to frequency count.
          </li>
        </ul>
      </div>
    ),
  },
];

const FormTermInput = (props) => {
  const {
    handleFormSubmit,
    termFormRef,
    handleInputChange,
    headTerm,
    termInput,
    tGen,
  } = props;

  return (
    <form onSubmit={handleFormSubmit} ref={termFormRef}>
      {!tGen ? (
        <HeadTermInput
          handleInputChange={handleInputChange}
          headTerm={headTerm}
        />
      ) : null}
      <h2 className="keygen-section-header">
        {tGen ? "TITLE WORDS GENERATOR" : "KEYWORDS RESEARCH"}
      </h2>
      <div className="term-input-additional-parent-container">
        {tGen
          ? tGenInputDetailsArr.map((inputDetailItem, i) => {
              return (
                <AdditionalTermInput
                  inputDetailItem={inputDetailItem}
                  key={inputDetailItem.source}
                  value={termInput[inputDetailItem.source]}
                  handleInputChange={handleInputChange}
                />
              );
            })
          : inputDetailsArr.map((inputDetailItem, i) => {
              return (
                <AdditionalTermInput
                  inputDetailItem={inputDetailItem}
                  key={inputDetailItem.source}
                  value={termInput[inputDetailItem.source]}
                  handleInputChange={handleInputChange}
                />
              );
            })}
      </div>

      <div id="process-button-container">
        <button
          type="submit"
          className="keygen-button"
          id="process-terms-button"
        >
          GENERATE
        </button>
      </div>
    </form>
  );
};

export default FormTermInput;
